import { Card, Skeleton, SkeletonText, VStack } from '@chakra-ui/react';

export function BannerSkeleton() {
  return (
    <Card.Root maxW="5xl" rounded="lg" shadow={'xs'}>
      <Card.Header borderBottom="1px solid" borderColor="gray.200" py="5">
        <VStack align="start" gap={'4'}>
          <Skeleton height="32px" width="200px" />
        </VStack>
      </Card.Header>
      <Card.Body p={6}>
        <VStack spacing={4} align="stretch">
          {[1, 2, 3].map((i) => (
            <Card.Root key={i} p={4} shadow="sm">
              <VStack align="stretch" spacing={3}>
                <Skeleton height="20px" width="40%" />
                <SkeletonText noOfLines={2} spacing={2} />
                <Skeleton height="20px" width="30%" />
              </VStack>
            </Card.Root>
          ))}
        </VStack>
      </Card.Body>
    </Card.Root>
  );
}
